export const priceSummaryRoute = {
  loadChildren: () =>
    import('./price-summary.module').then(m => m.PriceSummaryPageModule)
};
